import { render, staticRenderFns } from "./DuctsFS.vue?vue&type=template&id=a1ed1580"
import script from "./DuctsFS.vue?vue&type=script&lang=js"
export * from "./DuctsFS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports